
import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import ListComponent from '../../global/components/List/index.vue'
import {Language, Provider} from '../../global/models'
import axios from 'axios'
import { prettyDateTime } from '@/domains/global/functions/util'

@Component({
  components: { ListComponent }
})
export default class ProviderList extends Vue {
  languages: Language[] = []

  get filterOptions() {
    const options = this.formatFilterOptions(this.languages)
    return [
      { text: 'ID', key: 'id', type: 'number' },
      { text: 'Name', key: 'name', type: 'string' },
      { text: 'Email', key: 'email', type: 'string' },
      { text: 'Language', key: 'languageId', type: 'enum', options }
    ]
  }

  get availableColumns() {
    return [
      { text: 'Name', value: 'name' },
      { text: 'Email', value: 'email' },
      { text: 'Created', value: 'created', type: 'date', display: (date?: string) => prettyDateTime(date) },
      { text: 'Updated', value: 'updated', type: 'date', display: (date?: string) => prettyDateTime(date) }
    ]
  }

  get defaultColumns() {
    return ['name', 'email', 'created', 'updated']
  }
  
  get actions() {
    return [
      { text: 'View', method: (provider: Provider) => this.viewProvider(provider) }
    ]
  }

  get list() {
    return this.$refs.list as ListComponent<Provider>
  }

  viewProvider(provider: Provider) {
    this.$router.push({ name: 'providers-read', params: { id: provider.id.toString() } })
  }

  async getLanguages() {
    const response = await axios.get<Language[]>('languages/all')
    this.languages = response.data
  }

  async mounted() {
    await this.getLanguages()
  }

  formatFilterOptions(languages: Language[]) {
    return languages.map(language => { return { value: language.id, text: language.name } })
  }
}
